/**
 * Feature flags for the application
 * All flags default to false unless explicitly enabled via environment variables
 */

export const featureFlags = {
  // Social authentication providers
  enableGoogleAuth: process.env.REACT_APP_ENABLE_GOOGLE_AUTH === 'true',
  enableFacebookAuth: process.env.REACT_APP_ENABLE_FACEBOOK_AUTH === 'true',
  enableAppleAuth: process.env.REACT_APP_ENABLE_APPLE_AUTH === 'true',
  // Show login link in navigation (default: false for public-facing site)
  showLoginLink: process.env.REACT_APP_SHOW_LOGIN_LINK === 'true',
} as const;

/**
 * Check if any social auth provider is enabled
 */
export const hasSocialAuthEnabled = (): boolean => {
  return (
    featureFlags.enableGoogleAuth ||
    featureFlags.enableFacebookAuth ||
    featureFlags.enableAppleAuth
  );
};
